import PVChart from '../../common/pv-chart'

$(() => {
  if (!$('#owner-items_show').length) {
    return
  }

  new PVChart($('#pv'))
})